import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { ToastService, VendorService } from '@app/services';

@Component({
  selector: 'qb-confirmation-sent',
  templateUrl: './confirmation-sent.component.html',
  styleUrls: ['./confirmation-sent.component.scss'],
})
export class ConfirmationSentComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  vendorToken: string;

  constructor(
    private route: ActivatedRoute,
    private vendorService: VendorService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.vendorToken = this.route.snapshot.params['vendorToken'];
  }

  resend() {
    this.vendorService
      .resendVendorConfirmation(this.vendorToken)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.toastService.success('The confirmation email has been resent to your email address.', 'Success!');
      });
  }
}
